import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { initializeAuth, logout, showSessionExpiredDialog } from '../../store/slices/authSlice';

const PrivateRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, user, token } = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Ensure auth is initialized
    dispatch(initializeAuth());
    // Token expiration is now handled by TokenCheckWrapper
  }, [dispatch]);

  if (!isAuthenticated) {
    // Redirect to login while saving the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role-based access if required
  if (requiredRole && user?.profile?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute; 